import { useState, useEffect } from "react";
import { collection, getDocs, query, where } from "@firebase/firestore";
import { db } from "../../../services/firebaseService/connection";
import moment from "moment";
import { Table } from "antd";
import logger from "../../../utils/logger";
import SuperAdminContainer from "../SuperAdminContainer";
import { ScreenHeader } from "../../../CommonComponents";

const columns = [
  {
    title: "Match Id",
    dataIndex: "matchId",
    key: "matchId",
    className: "header-white",
  },
  {
    title: "Away Team",
    dataIndex: "awayTeam",
    key: "awayTeam",
    className: "header-white",
    render: (data) => (data ? data.name : "-"),
  },
  {
    title: "Home Team",
    dataIndex: "homeTeam",
    key: "homeTeam",
    className: "header-white",
    render: (data) => (data ? data.name : "-"),
  },
  {
    title: "League Id",
    dataIndex: "lId",
    key: "lId",
    className: "header-white",
  },
  {
    title: "Failed Tasks",
    dataIndex: "report",
    key: "status",
    className: "header-white",
    render: (data) => {
      if (data && typeof data === "object") {
        const failedTasks = Object.keys(data).filter((key) => data[key] === "fail");
        return (
          <div>
            <ul>
              {failedTasks.map((taskName) => (
                <li key={taskName}>{taskName}</li>
              ))}
            </ul>
          </div>
        );
      }
    },
  },
];

const StatusReport = () => {
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    const elements = document.querySelectorAll("th");
    elements.forEach((elem) => {
      elem.style.backgroundColor = "#000000";
    });

    try {
      const timestamp = moment().unix() * 1000 - 7 * 24 * 24 * 60 * 1000;
      const dbQuery = query(
        collection(db, "leaderBoardStatus"),
        where("timestamp", ">", timestamp.toString())
      );
      getDocs(dbQuery).then((snap) => {
        const data = [];
        for (let doc of snap.docs) {
          const docData = doc.data();
          for (let key in docData.matches) {
            if (key && !isNaN(Number(key))) {
              const matchData = docData.matches[key];
              matchData["matchId"] = key;
              matchData["timestamp"] = docData.timestamp || doc.id;
              data.push(matchData);
            }
          }
        }
        setTableData(data);
      });
    } catch (e) {
      logger.error(e);
    }
  }, []);

  return (
    <SuperAdminContainer>
      <ScreenHeader
        title="Match Day Status Report"
        elementCount={tableData.length}
      />
      <Table
        columns={columns}
        bordered
        dataSource={tableData}
        bodyStyle={{ backgroundColor: "#ffffff" }}
        scroll={{ x: true }}
        pagination={{
          position: ["bottomLeft"],
          defaultPageSize: 50,
          showSizeChanger: true,
          pageSizeOptions: [10, 20, 50, 100],
        }}
      />
    </SuperAdminContainer>
  );
};

export default StatusReport;
